import { render, staticRenderFns } from "./AboutWhyChooseUs.vue?vue&type=template&id=dd62c782&scoped=true&"
import script from "./AboutWhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./AboutWhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutWhyChooseUs.vue?vue&type=style&index=0&id=dd62c782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd62c782",
  null
  
)

export default component.exports